import React from 'react';
import PropTypes from 'prop-types';
import { CarouselProvider, Slider, Slide, DotGroup } from 'pure-react-carousel';

import { CarouselWrapper } from './Carousel.styles';

const CarouselComponent = (props) => {
  const { items, slideWidth, slideHeight, totalNumber, visibleSlides, slideRenderer } = props;

  return (
    <CarouselWrapper>
      <CarouselProvider
        naturalSlideWidth={slideWidth}
        naturalSlideHeight={slideHeight}
        totalSlides={totalNumber}
        visibleSlides={visibleSlides}
        isIntrinsicHeight
      >
        <Slider className="-mx-2">
          {items.map((item, index) => {
            const key = `slider-item-${index}`;
            return (
              <Slide index={index} key={key}>
                {slideRenderer(item)}
              </Slide>
            );
          })}
        </Slider>
        <DotGroup />
      </CarouselProvider>
    </CarouselWrapper>
  );
};

CarouselComponent.defaultProps = {
  items: [],
  slideWidth: 256,
  slideHeight: 340,
  totalNumber: 3,
  visibleSlides: 1,
};

CarouselComponent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  slideWidth: PropTypes.number,
  slideHeight: PropTypes.number,
  totalNumber: PropTypes.number,
  visibleSlides: PropTypes.number,
  slideRenderer: PropTypes.func.isRequired,
};

export default CarouselComponent;
